const SidebarInvestigationDetails = (id) => ({
  id: `investigation-${id}`,
  title: "Investigation Details",
  componentKey: "InvestigationSidebarContent",
  props: { investigationId: id }
});
export default SidebarInvestigationDetails;
